const API_URL = process.env.REACT_APP_API_URL;
// TODO: get from environment variable
const SHORT_CODE = '(513) 750-9622';

export default {
  API_URL,
  SHORT_CODE,
};
